"use strict";

var _ = require("./utils/mindash");

var warnings = {
  without: without,
  invokeConstant: true,
  reservedFunction: true,
  cannotFindContext: true,
  classDoesNotHaveAnId: true,
  stateIsNullOrUndefined: true,
  callingResolverOnServer: true,
  stateSourceAlreadyExists: true,
  superNotCalledWithOptions: true,
  promiseNotReturnedFromRemotely: true,
  contextNotPassedInToConstructor: true
};

module.exports = warnings;

function without(warningsToDisable, cb, context) {
  if (!_.isArray(warningsToDisable)) {
    warningsToDisable = [warningsToDisable];
  }

  if (context) {
    cb = _.bind(cb, context);
  }

  try {
    _.each(warningsToDisable, function (warning) {
      warnings[warning] = false;
    });

    cb();
  } finally {
    _.each(warningsToDisable, function (warning) {
      warnings[warning] = true;
    });
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/warnings.js
 ** module id = 249
 ** module chunks = 0
 **/